import React,{useEffect} from 'react'
import {  Link } from "react-router-dom";
import { useLocation,useNavigate } from 'react-router-dom'

export default function Index() {
  const location = useLocation();
  useEffect(() => {
    console.log(location.pathname);
  },[]);

  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    console.log('logout');
    window.location.href = '/';
  };


  return (
    <div className="appBottomMenu">
    <Link to="/home" className={`item  ${(location.pathname == '/home' && 'active')}`}>
      <div className="col">
        <ion-icon name="pie-chart-outline" />
        <strong>Overview</strong>
      </div>
    </Link>
  
    
    <Link to="/Transaction" className={`item  ${(location.pathname == '/Transaction' && 'active')}`}>
      <div className="col">
        <ion-icon name="card-outline" />
        <strong>Bill List</strong>
      </div>
    </Link>
    <Link to="/Denomination" className={`item  ${(location.pathname == '/Denomination' && 'active')}`}>
      <div className="col">
        <ion-icon name="cash-outline" />
        <strong>Denomination </strong>
      </div>
    </Link>
    <Link to="/Logout" className={`item  ${(location.pathname == '/Logout' && 'active')}`} 
         >
      <div className="col">
      <ion-icon name="arrow-forward-circle-outline"></ion-icon>
              <strong>Logout</strong>
      </div>
    </Link>
  </div>
  
  )
}
